module.exports = __webpack_public_path__ + "img/mcar.46bbbd03.jpg";